import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Button,
  Row,
  Col,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import * as pdfjsLib from "pdfjs-dist/build/pdf";

// Set the worker source
import {
  FaFolder,
  FaFilePowerpoint,
  FaFileWord,
  FaFile,
  FaArrowLeft,
  FaHome,
  FaFilePdf,
  FaEllipsisV,
  FaListUl,
  FaEye,
  FaEyeSlash,
  FaTimes,
} from "react-icons/fa";
import { FaRegFileImage } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import awsService from "../services/awsService";
import shareService from "../services/shareService";
import axios from "axios";
import { IoGridOutline } from "react-icons/io5";
import { useStateContext } from "../contexts/ContextProvider";
import { CiFileOn } from "react-icons/ci";
import "./viewfile.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdCopyAll, MdDownload } from "react-icons/md";
import Loading from "../components/Loading";
import FileViewer from "../components/FileViewer";
import Box from "@mui/material/Box";
import {
  X,
  Check,
  AlertCircle,
  Trash,
  ArrowUpFromLine,
  FileText,
} from "lucide-react";
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const ViewFile = () => {
  const { currentColor, currentMode } = useStateContext();
  const [uploading, setupLoading] = useState(false);
  const [downloading, setdownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [files, setFiles] = useState([]);
  const [sharedData, setsharedData] = useState({});
  const [currentPrefix, setCurrentPrefix] = useState("");
  const [previousPrefix, setPreviousPrefix] = useState("");
  const [writeAccess, setWriteAccess] = useState(false);
  const [downloadAccess, setDownloadAccess] = useState(false);
  const [viewOnly, setviewOnly] = useState(false);
  const [showShareModal, setShowShareModal] = useState(true);
  const [sharePassword, setSharePassword] = useState("");
  const [userPrefix, setUserPrefix] = useState("");
  const [viewType, setViewType] = useState("grid");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [startUploading, setstartUploading] = useState(false);

  const [Filename, setFilename] = useState("");
  const [parentPrefix, setParentPrefix] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [fileType, setFileType] = useState("");
  const [previewUrls, setPreviewUrls] = useState({});

  const [fileContent, setFileContent] = useState("");
  const [showCopyReplaceModal, setShowCopyReplaceModal] = useState(false);
  const [copyFilename, setcopyFilename] = useState("");
  const [uploadModal, setUploadModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [progressMap, setProgressMap] = useState({});
  const [showUploadListModal, setShowUploadListModal] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const params = useParams();

  const updateProgress = (percentage) => {
    console.log(`Upload Progress: ${percentage}%`);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadThumbnail = async (item) => {
    if (previewUrls[item.Key]) return; // Already loaded

    try {
      const blob = await awsService.PreviewUrlUser({
        Key: item.Key,
        shareId: sharedData.shareId,
      });
      const objectUrl = URL.createObjectURL(blob);
      setPreviewUrls((prev) => ({ ...prev, [item.Key]: objectUrl }));
    } catch (err) {
      console.error("Failed to load preview:", item.Key);
    }
  };
  const loadPdfThumbnail = async (item) => {
    try {
      console.log("item.key", item);
      if (previewUrls[item.Key]) return; // Already loaded

      // 1. Fetch the PDF blob
      const blob = await awsService.PreviewUrlUser({
        Key: item.Key,
        shareId: sharedData.shareId,
      });
      console.log(blob);
      // 2. Create a URL from blob
      const blobUrl = URL.createObjectURL(blob);

      // 3. Load the PDF
      const pdf = await pdfjsLib.getDocument(blobUrl).promise;
      const page = await pdf.getPage(1);
      console.log(page);
      // 4. Render the page to a canvas
      const scale = 1; // You can increase this if you want better resolution
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({ canvasContext: context, viewport }).promise;

      // 5. Get a base64 PNG preview
      const dataUrl = canvas.toDataURL();

      // 6. Save in previewUrls
      setPreviewUrls((prev) => ({
        ...prev,
        [item.Key]: dataUrl,
      }));
    } catch (error) {
      console.error("Failed to generate PDF thumbnail:", item.Key, error);
    }
  };

  useEffect(() => {
    const loadVisibleThumbnails = async () => {
      const imageTypes = ["jpg", "jpeg", "png", "avif"];
      const pdfTypes = ["pdf"];

      const visibleImageFiles = files.filter(
        (item) => item.Type !== "folder" && !previewUrls[item.Key]
      );

      for (const item of visibleImageFiles) {
        const ext = item?.Key?.split(".").pop()?.toLowerCase();

        if (imageTypes.includes(ext)) {
          await loadThumbnail(item); // Load image preview
        } else if (pdfTypes.includes(ext)) {
          await loadPdfThumbnail(item); // Load PDF preview
        }
      }
    };

    loadVisibleThumbnails();
  }, [files, previewUrls]); // 👈 Only depend on `files`, not `previewUrls`

  const fetchData = async (prefix) => {
    try {
      console.log(prefix);
      setLoading(true);
      const response = await awsService.getavailablefoldersforuser({
        shareId: sharedData.shareId,
        prefix: prefix,
      });
      //      const enhancedData = await Promise.all(
      //   response.map(async (item) => {
      //     const fileType = item?.Key?.split(".").pop()?.toLowerCase();
      //     const imageTypes = ["jpg", "jpeg", "png", "avif"];

      //     if (item.Type !== "folder" && imageTypes.includes(fileType)) {
      //       try {
      //         const blob = await awsService.PreviewUrlUser({
      //           Key: item.Key,
      //           shareId: sharedData.shareId,
      //         });

      //         const objectUrl = URL.createObjectURL(blob);
      //         console.log(objectUrl)
      //         return { ...item, previewUrl: objectUrl };
      //       } catch (err) {
      //         console.error("Failed to fetch preview for:", item.Key);
      //       }
      //     }

      //     return item;
      //   })
      // );
      let sortedData = response.sort((a, b) => {
        if (a.Type === "folder" && b.Type !== "folder") {
          return -1;
        }
        if (a.Type !== "folder" && b.Type === "folder") {
          return 1;
        }
        return 0;
      });
      sortedData = sortedData.filter((o) => o.Size !== 0);

      setFiles(sortedData);
      setLoading(false);
      console.log(response[0]?.ParentFolder);
      setCurrentPrefix(response[0]?.ParentFolder || prefix);
    } catch (error) {
      setLoading(false);

      console.error("Error fetching data:", error);
    }
  };

  const handleFolderClick = (folderKey, pf) => {
    setPreviousPrefix(pf);
    fetchData(folderKey);
  };

  const handleFileClick = (fileKey) => {
    // Handle downloading file
  };

  const handleBackClick = () => {
    console.log(
      Filename,
      "--------------",
      userPrefix,
      "----------",
      currentPrefix
    );
    if (
      previousPrefix === null ||
      previousPrefix === "" ||
      previousPrefix === userPrefix
    ) {
      setCurrentPrefix(userPrefix);
      fetchData(userPrefix);
    } else {
      const parts = currentPrefix.split("/");
      const newPrefix = parts.slice(0, -2).join("/");
      fetchData(newPrefix ? newPrefix + "/" : "");
    }
  };

  const handleHomeClick = () => {
    fetchData(userPrefix);
  };

  const handleDownloadLink = async (item) => {
    console.log(item);
    if (item.Type !== "folder") {
      // Form data to send to the server
      const formData = {
        shareId: sharedData.shareId,
        prefix: item.Key || item.Prefix,
      };

      try {
        // setdownloading(true);

        // Fetch the presigned URL for downloading the file
        let url = await awsService.downloadFileUser(formData);
        console.log("URL copied to clipboard:", url);
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url);
        } else {
          // Use the 'out of viewport hidden text area' trick
          const textArea = document.createElement("textarea");
          textArea.value = url;

          // Move textarea out of the viewport so it's not visible
          textArea.style.position = "absolute";
          textArea.style.left = "-999999px";

          document.body.prepend(textArea);
          textArea.select();

          try {
            document.execCommand("copy");
          } catch (error) {
            console.error(error);
          } finally {
            textArea.remove();
          }
        }

        // Display a toast notification
        // toast.success('Download link copied to clipboard!');
        toast.success(
          "Download link copied! This link is valid for the next 7 days.",
          {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      } catch (error) {
        console.error("Error downloading file:", error);
        setdownloading(false);
        setProgress(0);
      }
    }
  };
  const handleDownload = async (item) => {
    console.log(item);
    if (item.Type !== "folder") {
      // Form data to send to the server
      const formData = {
        shareId: sharedData.shareId,
        prefix: item.Key || item.Prefix,
      };

      try {
        setdownloading(true);

        // Fetch the presigned URL for downloading the file
        let url = await awsService.downloadFileUser(formData);

        // Download the file using Axios
        const response = await axios.get(url, {
          responseType: "blob", // This ensures the response is treated as a binary file
          onDownloadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
            updateProgress(percentCompleted); // Update progress here
          },
        });

        if (response.status === 200) {
          console.log("File downloaded successfully");

          // Create a URL for the downloaded file
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );

          // Create a link element to trigger the download
          const link = document.createElement("a");
          link.href = downloadUrl;
          let name = item.Key || item.Prefix;
          console.log(name, "name", item);
          if (item.Key) {
            name = item?.Key?.split("/")
              .filter((part) => part !== "")
              .pop();
            // name = item.Key.substring(item.Key.lastIndexOf("-") + 1);
          } else {
            name = item.Prefix.split("/")
              .filter((part) => part !== "")
              .pop();
          }
          console.log(name, "after");
          link.setAttribute("download", name); // Set the file name
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // Remove the link element
          setdownloading(false);
          setProgress(0);
        } else {
          console.error(
            "Failed to download file, status code:",
            response.status
          );
          setdownloading(false);
          setProgress(0);
        }
      } catch (error) {
        console.error("Error downloading file:", error);
        setdownloading(false);
        setProgress(0);
      }
    } else if (item.Type == "folder") {
      try {
        setLoading(true);
        const formData = {
          shareId: sharedData.shareId,
          prefix: item.Key || item.Prefix,
        };
        let response = await awsService.downloadFolderuser(formData);
        if (response) {
          const url = window.URL.createObjectURL(response); // response is already a Blob
          const a = document.createElement("a");
          a.href = url;
          a.download = `${item.Prefix}.zip`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

          setLoading(false);
          toast.success("file Downloaded!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handlelinkcopy = async (item) => {
    console.log(item);
    if (item.Type !== "folder") {
      // Form data to send to the server
      const formData = {
        shareId: sharedData.shareId,
        prefix: item.Key || item.Prefix,
      };

      try {
        setdownloading(true);

        let url = await awsService.downloadFileUser(formData);
        if (url) {
        }
      } catch (error) {
        console.error("Error downloading file:", error);
        setdownloading(false);
        setProgress(0);
      }
    } else if (item.Type == "folder") {
      try {
        setLoading(true);
        const formData = {
          shareId: sharedData.shareId,
          prefix: item.Key || item.Prefix,
        };
        let response = await awsService.downloadFolderuser(formData);
        if (response) {
          const url = window.URL.createObjectURL(response); // response is already a Blob
          const a = document.createElement("a");
          a.href = url;
          a.download = `${item.Prefix}.zip`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

          setLoading(false);
          toast.success("file Downloaded!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    getFilename();
  }, []);
  const handleShare = async () => {
    try {
      const response = await shareService.getSingleShare(params.id, {
        password: sharePassword,
      });
      if (response.status == "error") {
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      if (response) {
        setsharedData(response);
        setWriteAccess(response.uploadAccess);
        setDownloadAccess(response.downloadAccess);
        setviewOnly(response.viewOnlyAccess);
        setLoading(true);
        // const prefix =
        //   response.fileData.Type === "folder"
        //     ? response.fileData.Key
        //     : response.fileData.Prefix;
        const prefix = response.fileData.Key || response.fileData.Prefix;
        console.log(prefix, response.fileData);
        setUserPrefix(prefix);
        const response2 = await awsService.getavailablefoldersforuser({
          shareId: response.shareId,
        });
        //         const enhancedData = await Promise.all(
        //   response2.map(async (item) => {
        //     const fileType = item?.Key?.split(".").pop()?.toLowerCase();
        //     const imageTypes = ["jpg", "jpeg", "png", "avif"];

        //     if (item.Type !== "folder" && imageTypes.includes(fileType)) {
        //       try {
        //         const blob = await awsService.PreviewUrlUser({
        //           Key: item.Key,
        //           shareId: response.shareId,
        //         });

        //         const objectUrl = URL.createObjectURL(blob);
        //         console.log(objectUrl)
        //         return { ...item, previewUrl: objectUrl };
        //       } catch (err) {
        //         console.error("Failed to fetch preview for:", item.Key);
        //       }
        //     }

        //     return item;
        //   })
        // );
        let sortedData = response2.sort((a, b) => {
          if (a.Type === "folder" && b.Type !== "folder") {
            return -1;
          }
          if (a.Type !== "folder" && b.Type === "folder") {
            return 1;
          }
          return 0;
        });

        sortedData = sortedData.filter((o) => o.Size !== 0);
        setFiles(sortedData);
        setCurrentPrefix(prefix);
        setLoading(false);
        setShowShareModal(false);
      } else {
        setShowShareModal(true);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      if (error && error.response && error?.response?.data.status === "error") {
        let errormsg = error.response?.data.message || "Link Expired";
        toast.error(errormsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Internal Server Error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      console.error("Error sharing file:", error);
    }
  };
  const getFilename = async () => {
    try {
      const response = await shareService.getFilename(params.id, {});
      if (!response.success) {
        setLoading(false);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
      if (response.success) {
        let file = response.data.filename
          .split("/")
          .filter((part) => part !== "")
          .pop();
        console.log(file);
        let filename = file.substring(file.lastIndexOf("-") + 1);

        setParentPrefix(response.data.filename);
        setLoading(false);
        if (response.data.noPassword) {
          handleShare();
        } else {
          setFilename(file);
        }
      } else {
        setLoading(false);
        toast.error("Link Expired", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error("Link Expired", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error("Error sharing file:", error);
    }
  };
  const toggleGridView = () => {
    setViewType("grid");
  };

  const toggleListView = () => {
    setViewType("list");
  };
  const formatFileSize = (bytes) => {
    if (bytes >= 1024 ** 3) {
      return (bytes / 1024 ** 3).toFixed(2) + " GB";
    } else if (bytes >= 1024 ** 2) {
      return (bytes / 1024 ** 2).toFixed(2) + " MB";
    } else if (bytes >= 1024) {
      return (bytes / 1024).toFixed(2) + " KB";
    } else {
      return bytes + " B";
    }
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    console.log(files);
    setSelectedFiles(files);
    setProgressMap({});
    setShowUploadListModal(true);
  };

  const handleFolderUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const filesWithRelativePath = files;

    setSelectedFiles(filesWithRelativePath);
    setProgressMap({});
    setShowUploadListModal(true);
  };

  // const handleFileUpload = async (e) => {
  //   console.log("fileupload");
  //   const file = e.target.files[0];
  //   setFileContent(file);
  //   let newName = getFileNameWithoutExtension(file.name);
  //   setcopyFilename(newName);

  //   const formData = new FormData();
  //   formData.append("filename", file.name);
  //   formData.append("shareId", sharedData.shareId);
  //   formData.append("prefix", currentPrefix);

  //   try {
  //     setupLoading(true);
  //     let url = await awsService.uploadFileUser(formData);

  //     if (typeof url === "string") {
  //       setLoading(false);
  //       setupLoading(false);
  //       setShowCopyReplaceModal(true);
  //     } else {
  //       const response2 = await axios.put(url.imageData, file, {
  //         onUploadProgress: (progressEvent) => {
  //           const percentCompleted = Math.round(
  //             (progressEvent.loaded * 100) / progressEvent.total
  //           );
  //           setProgress(percentCompleted);
  //           updateProgress(percentCompleted);
  //         },
  //       });
  //       if (response2.status === 200) {
  //         setupLoading(false);
  //         setProgress(0);
  //         console.log("File uploaded successfully");
  //       } else {
  //         setupLoading(false);
  //         setProgress(0);
  //         console.error(
  //           "Failed to upload file, status code:",
  //           response2.status
  //         );
  //       }

  //       fetchData(currentPrefix);
  //     }
  //   } catch (error) {
  //     setupLoading(false);
  //     setProgress(0);
  //     console.error("Error uploading file:", error);
  //   }
  // };
  // const handleFolderUpload = async (e) => {
  //   console.log("folder upload");
  //   const files = Array.from(e.target.files);
  //   if (!files.length) return;

  //   setupLoading(true);

  //   try {
  //     for (const file of files) {
  //       // Optional: Set file content or preview first file
  //       setFileContent(file);

  //       const newName = getFileNameWithoutExtension(file.name);
  //       setcopyFilename(newName);

  //       const formData = new FormData();
  //       formData.append("filename", file.webkitRelativePath || file.name); // Include folder structure
  //       formData.append("shareId", sharedData.shareId);
  //       formData.append("prefix", currentPrefix);

  //       const url = await awsService.uploadFileUser(formData);

  //       if (typeof url === "string") {
  //         // Skip or handle error?
  //         console.warn(`Unexpected string response for file ${file.name}: ${url}`);
  //         continue;
  //       }

  //       const response2 = await axios.put(url.imageData, file, {
  //         onUploadProgress: (progressEvent) => {
  //           const percentCompleted = Math.round(
  //             (progressEvent.loaded * 100) / progressEvent.total
  //           );
  //           setProgress(percentCompleted);
  //           updateProgress(percentCompleted);
  //         },
  //       });

  //       if (response2.status === 200) {
  //         console.log(`File ${file.name} uploaded successfully`);
  //       } else {
  //         console.error(`Failed to upload ${file.name}, status:`, response2.status);
  //       }
  //     }

  //     setProgress(0);
  //     setupLoading(false);
  //     fetchData(currentPrefix);
  //   } catch (error) {
  //     console.error("Error uploading folder:", error);
  //     setupLoading(false);
  //     setProgress(0);
  //   }
  // };
  const uploadAllFiles = async () => {
    console.log(selectedFiles);
    setstartUploading(true);

    for (const file of selectedFiles) {
      const relativePath = file.webkitRelativePath || file.name;
      console.log(relativePath);

      const formData = new FormData();
      formData.append("filename", relativePath); // Preserve folder structure
      formData.append("shareId", sharedData.shareId);
      formData.append("prefix", currentPrefix);

      try {
        const url = await awsService.uploadFileUser(formData);
        console.log(url);
        // return
        await axios.put(url.imageData, file, {
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            setProgressMap((prev) => ({ ...prev, [relativePath]: percent }));
          },
        });

        setProgressMap((prev) => ({ ...prev, [relativePath]: 100 }));
      } catch (error) {
        console.error(`Error uploading ${relativePath}`, error);
        setProgressMap((prev) => ({ ...prev, [relativePath]: -1 }));
      }
    }

    setstartUploading(false);
    handleShare();
  };

  const handlePreviewFile = async (item) => {

    try {
      console.log("Dd")
      let fileType = item?.Key?.split(".").pop().toLowerCase(); // Convert to lowercase to ensure case-insensitive comparison
      let Types = ["png", "jpg", "jpeg", "gif", "mp4", "webm", "mp3", "wav"];
      if (Types.includes(fileType)) {
        console.log("File type is valid.");
        console.log(item);
        setLoading(true);
        const response = await awsService.PreviewUrlUser({
          Key: item.Key,
          shareId: sharedData.shareId,
        });

        // const blob = await response.blob();
        const url = URL.createObjectURL(response);

        setFileType(item?.Key?.split(".").pop());
        setLoading(false);
        setFileData(url);
        setShowModal(true);
      } else {
        if (downloadAccess) {
          handleDownload(item);
          // alert("File type is not supported");
          console.log("File type is not valid.");
        } else {
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const renderFileContent = () => {
    if (
      fileType === "png" ||
      fileType === "jpg" ||
      fileType === "jpeg" ||
      fileType === "gif" ||
      fileType === "avif"
    ) {
      return <img src={fileData} alt="File content" />;
    }
    if (fileType === "mp4" || fileType === "webm") {
      return <video src={fileData} controls />;
    }
    if (fileType === "mp3" || fileType === "wav") {
      return <audio src={fileData} controls />;
    }

    return <p>Unsupported file type</p>;
  };

  const handleClose = async () => {
    setShowModal(false);
  };

  const handleReplaceUpload = async () => {
    setLoading(true);
    const file = fileContent;
    console.log(file);
    setFileContent(file);
    const newname = getFileNameWithoutExtension(file.name);
    setcopyFilename(newname);
    const formData = new FormData();
    formData.append("filename", file.name);
    formData.append("shareId", sharedData.shareId);
    formData.append("prefix", currentPrefix);
    try {
      let url = await awsService.replaceUserFile(formData);
      const response2 = await axios.put(url.imageData, file, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          updateProgress(percentCompleted);
        },
      });
      if (response2.status === 200) {
        console.log("File uploaded successfully");
        // let url = awsService.updateDBUpload({
        //   prefix: currentPrefix,
        //   awsId,
        //   bucketName,
        // });
        // if (url) {
        //   setLoading(false);
        // }
        setShowModal(false);
        setLoading(true);
        setTimeout(async () => {
          fetchData(currentPrefix);
        }, 3000);

        console.log("dbupdated", "-------------------");
      } else {
        setLoading(false);
        console.error("Failed to upload file, status code:", response2.status);
      }

      // fetchData(currentPrefix);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };

  const handleCopyUpload = async () => {
    console.log(fileContent);

    const originalFile = fileContent; // Replace fileContent with the actual File object
    // Get the original file name without the extension
    const originalFileName = originalFile.name
      .split(".")
      .slice(0, -1)
      .join(".");
    // Get the file extension
    const fileExtension = originalFile.name.split(".").pop();
    const newName = getFileNameWithoutExtension(copyFilename);
    // Create a timestamp
    const timestamp = Date.now();

    // Create the new file name
    const newFileName = `${newName}.${fileExtension}`;

    // Create a new file with the desired name
    const newFile = new File([originalFile], newFileName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });

    handleFileUploadCopy(newFile);
  };
  const getFileNameWithoutExtension = (fileName) => {
    const parts = fileName.split(".");
    parts.pop(); // Remove the extension
    return parts.join("."); // Rejoin the remaining parts
  };

  const handleFileUploadCopy = async (e) => {
    console.log(sharedData, "-----");
    setLoading(true);
    const file = e;
    console.log(file);
    setFileContent(file);
    const newname = getFileNameWithoutExtension(file.name);
    setcopyFilename(newname);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("shareId", sharedData.shareId);
    formData.append("prefix", currentPrefix);

    try {
      let url = await awsService.uploadFileUser(formData);
      if (typeof url === "string") {
        setLoading(false);
        setupLoading(false);
        setShowCopyReplaceModal(true);
      } else {
        const response2 = await axios.put(url.imageData, file, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            updateProgress(percentCompleted);
          },
        });
        if (response2.status === 200) {
          console.log("File uploaded successfully");
          // let url = awsService.updateDBUpload({
          //   prefix: currentPrefix,
          //   awsId,
          //   bucketName,
          // });
          // if (url) {
          //   setLoading(false);
          // }
          setShowModal(false);
          setLoading(true);
          setTimeout(async () => {
            fetchData(currentPrefix);
          }, 5000);

          console.log("dbupdated", "-------------------");
        } else {
          setLoading(false);
          console.error(
            "Failed to upload file, status code:",
            response2.status
          );
        }
      }

      // fetchData(currentPrefix);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };

  const totalFiles = selectedFiles.length;

  // Check status based on webkitRelativePath or file name if webkitRelativePath doesn't exist
  const completedFiles = selectedFiles.filter((file) => {
    const key = file.webkitRelativePath || file.name;
    return progressMap[key] === 100;
  }).length;

  const failedFiles = selectedFiles.filter((file) => {
    const key = file.webkitRelativePath || file.name;
    return progressMap[key] === -1;
  }).length;

  const pendingFiles = totalFiles - completedFiles - failedFiles;

  // Group files by status
  const pendingFilesList = selectedFiles.filter((file) => {
    const key = file.webkitRelativePath || file.name;
    return progressMap[key] !== 100 && progressMap[key] !== -1;
  });

  const completedFilesList = selectedFiles.filter((file) => {
    const key = file.webkitRelativePath || file.name;
    return progressMap[key] === 100;
  });

  const failedFilesList = selectedFiles.filter((file) => {
    const key = file.webkitRelativePath || file.name;
    return progressMap[key] === -1;
  });

  return (
    <div className="w-full ">
      {!showShareModal && (
        <img
          src="/doclogo-horizontal.png"
          alt="DocBox Logo"
          className=" h-12 w-48 mt-4 ml-5 "
        />
      )}

      {loading && (
        <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50">
          <div
            className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
            style={{
              borderTopColor: "white",
              borderBottomColor: "white",
            }}
          ></div>
          <p className="mt-4 text-white">Loading...</p>
        </div>
      )}

      <div>
        {" "}
        <style>
          {`
      body {
        background-image: url("/logbg.avif");
        background-size: cover; 
        background-repeat: no-repeat;
        overflow:hidden
        margin: 0;
        padding: 0;
      }
    `}
        </style>
        {!showShareModal ? (
          <Container fluid className="p-4">
            {uploading && (
              <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50 text-white">
                <div
                  className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
                  style={{
                    borderTopColor: "white",
                    borderBottomColor: "white",
                  }}
                ></div>
                <p className="mt-4">loading... {progress}%</p>
                <div className="progress w-3/4 mt-2">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}%
                  </div>
                </div>
              </div>
            )}
            {downloading && (
              <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50 text-white">
                <div
                  className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
                  style={{
                    borderTopColor: "white",
                    borderBottomColor: "white",
                  }}
                ></div>
                <p className="mt-4">Downloading... {progress}%</p>
                <div className="progress w-3/4 mt-2">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}%
                  </div>
                </div>
              </div>
            )}
            <hr className="border-t border-gray-500 my-3" />

            <div className="flex justify-between items-center naving">
              <div className="flex space-x-2">
                {parentPrefix != currentPrefix && (
                  <>
                    <button
                      className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                      onClick={handleBackClick}
                      data-tip="Back"
                    >
                      <FaArrowLeft
                        className="mr-1"
                        style={{ fontSize: "1.3rem" }}
                      />
                    </button>
                    <button
                      className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                      onClick={handleHomeClick}
                      data-tip="Home"
                    >
                      <FaHome className="mr-3" style={{ fontSize: "1.5rem" }} />
                    </button>
                    {/* <h1 className="text-2xl font-bold ml-3  text-gray-500">Doc Box</h1> */}
                  </>
                )}
                <h3
                  class=" text-2xl font-semibold tracking-wide mt-2 ml-2"
                  style={{
                    color: "#535353",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  {Filename || ""}
                </h3>
              </div>
              {/* <div className="flex space-x-2">
                <div className="flex space-x-2">
                  <label>{files.length}</label>
                  <button
                    className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                    onClick={toggleListView}
                    title="Toggle List View"
                    data-tip="List View"
                  >
                    <FaListUl className="mr-2" style={{ fontSize: "1.4rem" }} />
                  </button>
                  <button
                    className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                    onClick={toggleGridView}
                    title="Toggle Grid View"
                    data-tip="Grid View"
                  >
                    <IoGridOutline
                      className="mr-2"
                      style={{ fontSize: "1.4rem" }}
                    />
                  </button>
                </div>
                {writeAccess && (
                  <label
                    className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 cursor-pointer"
                    style={{ backgroundColor: currentColor }}
                    onClick={() => setUploadModal(true)}

                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                    
                  </label>
                )}
              </div> */}

              <div className="flex space-x-2">
                <div className="flex space-x-2">
                  <div className="flex items-center justify-start gap-2 py-2 px-3 bg-gray-50 rounded-md border border-gray-200">
                    <FileText size={16} className="text-blue-500" />
                    <span className="text-gray-700 font-medium text-sm">
                      {files.length} item{files.length !== 1 ? "s" : ""}
                    </span>
                  </div>

                  {/* Toggle buttons for List and Grid view */}
                  <button
                    className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                    onClick={toggleListView}
                    title="Toggle List View"
                    data-tip="List View"
                  >
                    <FaListUl className="mr-2" style={{ fontSize: "1.4rem" }} />
                  </button>
                  <button
                    className="text-gray-500 bg-transparent hover:bg-gray-100 rounded p-2"
                    onClick={toggleGridView}
                    title="Toggle Grid View"
                    data-tip="Grid View"
                  >
                    <IoGridOutline
                      className="mr-2"
                      style={{ fontSize: "1.4rem" }}
                    />
                  </button>
                </div>

                {/* Conditional upload button based on write access */}
                {writeAccess && (
                  <label
                    className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 cursor-pointer"
                    style={{ backgroundColor: currentColor }}
                    onClick={() => setUploadModal(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                  </label>
                )}
              </div>
            </div>

            <hr className="border-t border-gray-500 my-4" />

            {viewType === "grid" ? (
              <div  className="w-full">
              <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(250px,390px))]">
                {files.map((item, index) => (
                  <div className="relative">
                    {/* {item.Type && (
                      <div
                        className="d-flex absolute top-0 right-0 mt-2 mr-6"
                        style={{ zIndex: "5" }}
                      >
                        <span
                          onClick={
                            item.Type === "folder"
                              ? () =>
                                  handleFolderClick(
                                    item.Prefix,
                                    item.ParentFolder
                                  )
                              : (e) => {
                                  e.stopPropagation();
                                  handleDownloadLink(item);
                                }
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <>
                            {downloadAccess && (
                              <>
                                {item.Type !== "folder" && (
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDownloadLink(item);
                                    }}
                                    style={{ cursor: "pointer", zIndex: 10 }}
                                    title="Copy Download Link"
                                    className="hover-icon"
                                  >
                                    <MdCopyAll
                                      size={25}
                                      style={{
                                        marginTop: "26px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </span>
                                )}

                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDownload(item);
                                  }}
                                  style={{ cursor: "pointer", zIndex: 10 }}
                                  title="Download File"
                                  className="hover-icon"
                                >
                                  <MdDownload
                                    size={25}
                                    style={{
                                      marginTop: "10px",
                                      marginRight: "10px",
                                    }}
                                  />
                                </span>
                              </>
                            )}
                          </>
                        </span>
                      </div>
                    )} */}
                    <div
                      key={index}
                      className="rounded-lg shadow-md cursor-pointer relative border-t-4 border-b-4 border-l border-r border-gray-300 bg-white  grid-item"
                      style={{ maxWidth: "400px", minHeight: "165px" }}
                      onClick={
                        item.Type === "folder"
                          ? () =>
                              handleFolderClick(item.Prefix, item.ParentFolder)
                          : (e) => {
                              e.stopPropagation();
                              handlePreviewFile(item);
                            }
                      }
                    >
                      {item.Type === "folder" ? (
                        <>
                        <div style={{minHeight: 140}} className="d-flex justify-content-center align-items-center">
                              <FaFolder
                            size={100}
                            style={{ color: currentColor }}
                            onClick={() =>
                              handleFolderClick(item.Prefix, item.ParentFolder)
                            }
                            />
                        </div>
                        <div className="p-2 d-flex justify-content-between align-items-center gap-2">
                          {/* <span style={{width:30}}>
                            <FaFolder
                            size={30}
                            style={{ color: currentColor }}
                            onClick={() =>
                              handleFolderClick(item.Prefix, item.ParentFolder)
                            }
                            />
                          </span> */}
                          <span
                            className="flex-grow"
                             style={{
    display: "inline-block",
    maxWidth: "300px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontFamily: "Poppins, sans-serif",
    cursor: "pointer"
  }}
                            title={item?.Key?.split("/")
                              .filter((part) => part !== "")
                              .pop()}
                          >
                            {item.Prefix.split("/")
                              .filter((part) => part !== "")
                              .pop()}
                          </span>
                          {downloadAccess && (
                            <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDownload(item);
                                  }}
                                  style={{ cursor: "pointer", zIndex: 10 }}
                                  title="Download File"
                                  className="hover-icon"
                                >
                                  <MdDownload
                                    size={25}
                                  />
                                </span> 
                          )}
  <>
                                  
                              </>
                             
                          </div>
                        </>
                      ) : (
                        <>
                        <div style={{minHeight: 140}} className="d-flex justify-content-center align-items-center">

                          {(() => {
                            const ext = item?.Key?.split(".")
                              .pop()
                              ?.toLowerCase();
                            const isImage = [
                              "jpg",
                              "jpeg",
                              "png",
                              "avif",
                            ].includes(ext);
                            const isPdf = ext === "pdf";
                            const isDoc = ["doc", "docx"].includes(ext);
                            const isPpt = ["ppt", "pptx"].includes(ext);

                            if (isImage) {
                              return previewUrls[item.Key] ? (
                                // ✅ Image loaded — show image with download
                              
                                  <img
                                    src={previewUrls[item.Key]}
                                    alt="thumbnail"
                                    style={{
                                      width: "100%",
                                    maxHeight: "140px",

                                      objectFit: "cover",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  />
                              ) : (
                                // ⏳ Image loading — show placeholder
                                <div
                                  onMouseEnter={() => loadThumbnail(item)}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                  title="Loading preview..."
                                >
                                  <FaRegFileImage
                                    size={24}
                                    style={{ color: currentColor }}
                                  />
                                </div>
                              );
                            } else if (isPdf) {
                              return previewUrls[item.Key] ? (
                          
                                  <img
                                    src={previewUrls[item.Key]}
                                    alt="pdf preview"
                                    style={{
                                      width: "100%",
                                      objectFit: "cover",
                                      borderRadius: "4px",
                                    maxHeight: "140px",

                                      cursor: "pointer",
                                    }}
                                  />
                              ) : (
                                <div
                                  onMouseEnter={() => loadPdfThumbnail(item)}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                  title="Loading PDF preview..."
                                >
                                  <FaFilePdf
                                    size={24}
                                    style={{ color: "#E74C3C" }}
                                  />
                                </div>
                              );
                            } else if (isDoc) {
                              return (
                                <FaFileWord
                                  size={50}
                                  style={{
                                    color: "#2E86C1",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleFileClick(item.Key)}
                                  title="Word Document"
                                />
                              );
                            } else if (isPpt) {
                              return (
                                <FaFilePowerpoint
                                  size={50}
                                  style={{
                                    color: "#D35400",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleFileClick(item.Key)}
                                  title="PowerPoint Presentation"
                                />
                              );
                            } else {
                              return (
                                <CiFileOn
                                  size={50}
                                  className="mr-3 cursor-pointer"
                                  style={{ color: currentColor }}
                                  onClick={() => handleFileClick(item.Key)}
                                  title="File"
                                />
                              );
                            }
                          })()}
                          
                          </div>
                        <div className="p-2 d-flex justify-content-between align-items-center gap-2">
                 <span
  className="flex-grow d-flex align-items-center gap-2"
  style={{
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap", // Keep everything on a single line
    maxWidth: "300px",
    cursor: "pointer",
    fontFamily: "Poppins, sans-serif",
  }}
>
  <span
    style={{
      width: "20px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
  >
    {
      (() => {
        const ext = item?.Key?.split(".").pop()?.toLowerCase();
        const isImage = ["jpg", "jpeg", "png", "avif"].includes(ext);
        const isPdf = ext === "pdf";
        const isDoc = ["doc", "docx"].includes(ext);
        const isPpt = ["ppt", "pptx"].includes(ext);
        const hasPreview = !!previewUrls[item.Key];

        const iconSize = 16;

        if (isImage && hasPreview) return <FaRegFileImage size={iconSize} style={{ color: currentColor }} />;
        if (isPdf && hasPreview) return <FaFilePdf size={iconSize} style={{ color: "#E74C3C" }} />;
        if (isDoc) return <FaFileWord size={iconSize} style={{ color: "#2E86C1" }} />;
        if (isPpt) return <FaFilePowerpoint size={iconSize} style={{ color: "#D35400" }} />;
        return <CiFileOn size={iconSize} style={{ color: currentColor }} />;
      })()
    }
  </span>

  <span
    style={{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {item?.Key?.split("/").filter((part) => part !== "").pop()}
  </span>
</span>

                          {downloadAccess && (
                            <><span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDownloadLink(item);
                                  } }
                                  style={{ cursor: "pointer", zIndex: 10 }}
                                  title="Copy Download Link"
                                  className="hover-icon"
                                >
                                  <MdCopyAll
                                    size={25}
                                    />
                                </span><span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDownload(item);
                                  } }
                                  style={{ cursor: "pointer", zIndex: 10 }}
                                  title="Download File"
                                  className="hover-icon"
                                >
                                    <MdDownload
                                      size={25}
                                  />
                                  </span></>
                          )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              </div>
            ) : (
              <div>
                {files.map((item, index) => (
                  <React.Fragment key={index}>
                    <div
                      className={`flex items-center p-2 ${
                        currentMode === "Dark" ? "text-white" : "bg-white"
                      }`}
                      style={{
                        backgroundColor:
                          currentMode === "Dark" ? "#33373E" : "white",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (item.Type === "folder") {
                          handleFolderClick(item.Prefix, item.ParentFolder);
                        } else if (item.Type === "file") {
                          handlePreviewFile(item);
                        }
                      }}
                    >
                      {item.Type === "folder" ? (
                        <>
                          <FaFolder
                            size={40}
                            className="mr-3 cursor-pointer"
                            style={{ color: currentColor ,marginRight: "10px" }}
                            onClick={() =>
                              handleFolderClick(item.Prefix, item.ParentFolder)
                            }
                          />
                          <span
                            className="flex-grow "
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          >
                            {item.Prefix.split("/")
                              .filter((part) => part !== "")
                              .pop()}
                          </span>
                        </>
                      ) : (
                        <>
                          {/* {["jpg","jpeg", "png", "avif"].includes(
                            item?.Key?.split(".").pop().toLowerCase()
                          ) ? (
                            <FaRegFileImage
                              size={30}
                              className="mr-3 cursor-pointer"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          ) : (
                            <CiFileOn
                              size={30}
                              className="mr-3 cursor-pointer"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          )} */}
                          {(() => {
                            const ext = item?.Key?.split(".")
                              .pop()
                              ?.toLowerCase();
                            const isImage = [
                              "jpg",
                              "jpeg",
                              "png",
                              "avif",
                            ].includes(ext);
                            const isPdf = ext === "pdf";
                            const isDoc = ["doc", "docx"].includes(ext);
                            const isPpt = ["ppt", "pptx"].includes(ext);

                            if (isImage) {
                              return previewUrls[item.Key] ? (
                                // ✅ Image loaded — show image with download
             
                                  <img
                                    src={previewUrls[item.Key]}
                                    alt="thumbnail"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      objectFit: "cover",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      marginRight : "10px"
                                    }}
                                  />
                              ) : (
                                // ⏳ Image loading — show placeholder
                                <div
                                  onMouseEnter={() => loadThumbnail(item)}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    marginRight : "10px"
                                  }}
                                  title="Loading preview..."
                                >
                                  <FaRegFileImage
                                    size={24}
                                    style={{ color: currentColor }}
                                  />
                                </div>
                              );
                            } else if (isPdf) {
                              return previewUrls[item.Key] ? (
    
                                  <img
                                    src={previewUrls[item.Key]}
                                    alt="pdf preview"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      objectFit: "cover",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      marginRight : "10px"
                                    }}
                                  />
                              ) : (
                                <div
                                  onMouseEnter={() => loadPdfThumbnail(item)}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                  title="Loading PDF preview..."
                                >
                                  <FaFilePdf
                                    size={40}
                                    style={{ color: "#E74C3C" , marginRight: "10px" }}
                                  />
                                </div>
                              );
                            } else if (isDoc) {
                              return (
                                <FaFileWord
                                  size={40}
                                  style={{
                                    color: "#2E86C1",
                                    cursor: "pointer",
                                    marginRight: "10px" 
                                  }}
                                  onClick={() => handleFileClick(item.Key)}
                                  title="Word Document"
                                />
                              );
                            } else if (isPpt) {
                              return (
                                <FaFilePowerpoint
                                  size={40}
                                  style={{
                                    color: "#D35400",
                                    cursor: "pointer",
                                    marginRight: "10px" 
                                  }}
                                  onClick={() => handleFileClick(item.Key)}
                                  title="PowerPoint Presentation"
                                />
                              );
                            } else {
                              return (
                                <CiFileOn
                                  size={40}
                                  className="mr-3 cursor-pointer"
                                  style={{ color: currentColor , marginRight: "10px"  }}
                                  onClick={() => handleFileClick(item.Key)}
                                  title="File"
                                />
                              );
                            }
                          })()}
                          <span
                            className="flex-grow"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          >
                            {item?.Key?.split("/")
                              .filter((part) => part !== "")
                              .pop()}
                            {/* {item.Key.substring(item.Key.lastIndexOf("-") + 1)} */}
                          </span>
                        </>
                      )}
                      {item.Type !== "folder" &&
                        // <div className="ml-auto flex items-center z-10">
                        //   <span
                        //     onClick={(e) => {
                        //       e.stopPropagation();
                        //       handleDownloadLink(item);
                        //     }}
                        //     style={{ cursor: "pointer" }}
                        //     title="Copy Download Link"
                        //     className="hover-icon"
                        //   >
                        //     <MdCopyAll
                        //       size={25}
                        //       style={{ marginRight: "10px", marginTop: "10px" }}
                        //     />
                        //   </span>
                        //   <span
                        //     onClick={() => handleDownload(item)}
                        //     style={{ cursor: "pointer" }}
                        //     title="Download File"
                        //     className="hover-icon"
                        //   >
                        //     <MdDownload
                        //       size={25}
                        //       style={{
                        //         color: currentMode === "Dark" ? "#fff" : "",
                        //       }}
                        //     />
                        //   </span>
                        // </div>
                        downloadAccess && (
                          <div className="ml-auto flex items-center z-10">
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadLink(item);
                              }}
                              style={{ cursor: "pointer" }}
                              title="Copy Download Link"
                              className="hover-icon"
                            >
                              <MdCopyAll
                                size={25}
                                style={{
                                  marginRight: "10px",
                                }}
                              />
                            </span>
                            <span
                              onClick={() => handleDownload(item)}
                              style={{ cursor: "pointer" }}
                              title="Download File"
                              className="hover-icon"
                            >
                              <MdDownload
                                size={25}
                                style={{
                                  color: currentMode === "Dark" ? "#fff" : "",
                                }}
                              />
                            </span>
                          </div>
                        )}
                    </div>
                    {index !== files.length - 1 && (
                      <div
                        className="mx-2 border-b"
                        style={{
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          backgroundColor:
                            currentMode === "Dark" ? "#33373E" : "white",
                        }}
                      ></div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </Container>
        ) : Filename ? (
          <div className="flexbox">
            <div className="flexCenterBox">
              <div className="logoBox">
                <img
                  src="/doclogo-horizontal.png"
                  alt="DocBox Logo"
                  className=" h-12 w-48 "
                />
              </div>
              <div className="card shadow">
                <div className="card-header">
                  <h5 className="card-title text-center p-3">
                    Please Enter Password
                  </h5>
                </div>
                <div className="card-body p-4">
                  <p className="mb-4">
                    You've received a link to a file that requires a password.
                  </p>
                  <div
                    className="filename-container mb-4 text-center"
                    style={{
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      background: "#f8f9fa",
                      padding: "10px",
                    }}
                  >
                    <h4
                      className="filename"
                      style={{
                        fontSize: "1rem",
                      }}
                    >
                      {Filename}
                    </h4>
                  </div>
                  <p className="mb-4">
                    To open the content, enter the password. If you don't have
                    the link password, ask the person who shared the content
                    with you.
                  </p>
                  <div className="input-group mb-4">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Password"
                      value={sharePassword}
                      onChange={(e) => setSharePassword(e.target.value)}
                    />
                    <span
                      className="input-group-text password-toggle"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={handleShare}
                    style={{ backgroundColor: "#036bb3" }}
                  >
                    Verify
                  </button>
                </div>
                {/* <div className="card-footer">
              <button className="btn btn-primary w-100" onClick={handleShare}>Verify</button>
            </div> */}
              </div>
            </div>
          </div>
        ) : (
          <Loading loading={"loading"} currentColor={currentColor} />
        )}
        <div>
          <ToastContainer />
        </div>
      </div>

      <Modal
        show={showCopyReplaceModal}
        onHide={() => setShowCopyReplaceModal(false)}
        backdrop="static"
        keyboard={false}
        className="modal-dialog-centered"
      >
        <Modal.Header className="bg-white border-b border-gray-300">
          {/* <div class="p-3 mb-2 bg-warning text-dark">File name already exists. Copy or Replace</div> */}
          <div className="text-xl font-semibold text-gray-600">
            Rename or Replace
          </div>
          <Button
            variant="light"
            onClick={() => setShowCopyReplaceModal(false)}
            className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
          >
            <FaTimes color="gray" />
          </Button>
        </Modal.Header>
        <Modal.Body className="p-6 overflow-auto">
          <Form>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1 },
              }}
              noValidate
              autoComplete="off"
            >
              <div className="flex mb-3">
                <div className="flex-1 mr-2">
                  <input
                    type="text"
                    placeholder="Filename"
                    value={copyFilename}
                    onChange={(e) => setcopyFilename(e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
              {/* <div className="flex mb-3">
          <div className="flex-1 mr-2">
            <TextField
              label="Filename"
              value={fileContent.name}
              InputProps={{
                readOnly: false,
              }}
              variant="outlined"
              size="small"
              fullWidth
            />
          </div>
        </div> */}
            </Box>
          </Form>
        </Modal.Body>
        <Modal.Footer className="bg-gray-200 border-t border-gray-300 flex justify-end">
          <Button
            variant="primary"
            onClick={() => {
              // Implement the copy functionality here
              console.log("Copy clicked");
              setShowCopyReplaceModal(false);
              handleCopyUpload();
            }}
            className="mr-2"
          >
            Rename
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              // Implement the replace functionality here
              console.log("Replace clicked");
              setShowCopyReplaceModal(false);
              handleReplaceUpload();
            }}
          >
            Replace
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showCopyReplaceModal}
        onHide={() => setShowCopyReplaceModal(false)}
        backdrop="static"
        keyboard={false}
        className="modal-dialog-centered"
      >
        <Modal.Header className="bg-white border-b border-gray-300">
          {/* <div class="p-3 mb-2 bg-warning text-dark">File name already exists. Copy or Replace</div> */}
          <div className="text-xl font-semibold text-gray-600">
            Rename or Replace
          </div>
          <Button
            variant="light"
            onClick={() => setShowCopyReplaceModal(false)}
            className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
          >
            <FaTimes color="gray" />
          </Button>
        </Modal.Header>
        <Modal.Body className="p-6 overflow-auto">
          <Form>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1 },
              }}
              noValidate
              autoComplete="off"
            >
              <div className="flex mb-3">
                <div className="flex-1 mr-2">
                  <input
                    type="text"
                    placeholder="Filename"
                    value={copyFilename}
                    onChange={(e) => setcopyFilename(e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
              {/* <div className="flex mb-3">
          <div className="flex-1 mr-2">
            <TextField
              label="Filename"
              value={fileContent.name}
              InputProps={{
                readOnly: false,
              }}
              variant="outlined"
              size="small"
              fullWidth
            />
          </div>
        </div> */}
            </Box>
          </Form>
        </Modal.Body>
        <Modal.Footer className="bg-gray-200 border-t border-gray-300 flex justify-end">
          <Button
            variant="primary"
            onClick={() => {
              // Implement the copy functionality here
              console.log("Copy clicked");
              setShowCopyReplaceModal(false);
              handleCopyUpload();
            }}
            className="mr-2"
          >
            Rename
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              // Implement the replace functionality here
              console.log("Replace clicked");
              setShowCopyReplaceModal(false);
              handleReplaceUpload();
            }}
          >
            Replace
          </Button>
        </Modal.Footer>
      </Modal>
      {uploadModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-6 relative">
            <button
              className="absolute top-0 right-0 p-2 text-gray-500 bg- hover:text-gray-700"
              onClick={() => setUploadModal(false)}
            >
              <FaTimes />
            </button>
            <div className="flex justify-around">
              <label className=" px-4 py-2 rounded cursor-pointer">
                <FaFolder
                  size={50}
                  className="mb-3 "
                  style={{ color: currentColor }}
                />
                Upload Folder
                <input
                  type="file"
                  webkitdirectory="true"
                  className="hidden"
                  onChange={(e) => {
                    handleFolderUpload(e);
                    setUploadModal(false);
                  }}
                />
              </label>
              <label className=" px-4 py-2 rounded cursor-pointer">
                <FaFile
                  size={50}
                  className="mb-3 "
                  style={{ color: currentColor }}
                />
                Upload File
                <input
                  type="file"
                  multiple
                  className="hidden"
                  onChange={(e) => {
                    handleFileUpload(e);
                    setUploadModal(false);
                  }}
                />
              </label>
            </div>
          </div>
        </div>
      )}

      {showUploadListModal && (
        // <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        //   <div className="bg-white rounded-lg p-6 relative w-[500px] max-h-[80vh] overflow-y-auto">
        //     <h2 className="text-lg font-semibold mb-4">Upload Progress</h2>

        //     {selectedFiles.map((file) => (
        //       <div key={file.name} className="mb-3">
        //         <div className="text-sm truncate">{file.name}</div>
        //         <div className="w-full bg-gray-200 rounded h-3 mt-1">
        //           <div
        //             className={`h-3 rounded ${
        //               progressMap[file.name] === -1
        //                 ? "bg-red-500"
        //                 : "bg-blue-500"
        //             }`}
        //             style={{ width: `${progressMap[file.name] || 0}%` }}
        //           ></div>
        //         </div>
        //         <div className="text-xs text-right mt-1">
        //           {progressMap[file.name] === -1
        //             ? "Failed"
        //             : `${progressMap[file.name] || 0}%`}
        //         </div>
        //       </div>
        //     ))}

        //     <div className="mt-4 flex justify-between">
        //       <button
        //         className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
        //         onClick={() => setShowUploadListModal(false)}
        //       >
        //         Close
        //       </button>
        //       <button
        //         className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        //         onClick={uploadAllFiles}
        //       >
        //         Start Upload
        //       </button>
        //     </div>
        //   </div>
        // </div>

        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-xl p-6 relative w-[750px] max-h-[80vh] overflow-hidden flex flex-col">
            {/* Header with close button */}
            <div className="flex justify-between items-center mb-4 pb-3 border-b">
              <h2 className="text-xl font-semibold text-gray-800">
                File Upload
              </h2>
              <button
                onClick={() => setShowUploadListModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X size={20} />
              </button>
            </div>

            {/* Stats summary */}
            <div className="grid grid-cols-3 gap-3 mb-4">
              <div className="bg-blue-50 p-3 rounded-md">
                <div className="text-blue-700 text-sm font-medium">Total</div>
                <div className="text-xl font-semibold">{totalFiles}</div>
              </div>
              <div className="bg-green-50 p-3 rounded-md">
                <div className="text-green-700 text-sm font-medium">
                  Completed
                </div>
                <div className="text-xl font-semibold">{completedFiles}</div>
              </div>
              <div className="bg-red-50 p-3 rounded-md">
                <div className="text-red-700 text-sm font-medium">Failed</div>
                <div className="text-xl font-semibold">{failedFiles}</div>
              </div>
            </div>

            {/* Files list with sections */}
            <div className="overflow-y-auto flex-grow">
              {/* Pending files */}
              {pendingFilesList.length > 0 && (
                <div className="mb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">
                    PENDING ({pendingFiles})
                  </h3>
                  {pendingFilesList.map((file) => (
                    <div
                      key={file.name}
                      className="mb-3 bg-gray-50 p-3 rounded"
                    >
                      <div className="flex justify-between">
                        <div className="text-sm truncate max-w-[400px]">
                          {file.webkitRelativePath || file.name}
                        </div>
                        <span className="text-xs text-gray-500 ml-2">
                          {formatFileSize(file.size)}
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
                        <div
                          className="h-2 rounded-full bg-blue-500"
                          style={{ width: `${progressMap[file.name] || 0}%` }}
                        ></div>
                      </div>
                      <div className="text-xs text-right mt-1 text-gray-500">
                        {progressMap[file.name] || 0}%
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Completed files */}
              {completedFilesList.length > 0 && (
                <div className="mb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">
                    COMPLETED ({completedFilesList.length})
                  </h3>
                  {completedFilesList.map((file) => (
                    <div
                      key={file.name}
                      className="mb-2 bg-green-50 p-3 rounded flex items-center"
                    >
                      <Check size={16} className="text-green-500 mr-2" />
                      <div className="text-sm truncate flex-grow">
                        {file.webkitRelativePath || file.name}
                      </div>
                      <span className="text-xs text-green-600 font-medium">
                        100%
                      </span>
                    </div>
                  ))}
                </div>
              )}

              {/* Failed files */}
              {failedFilesList.length > 0 && (
                <div className="mb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">
                    FAILED ({failedFilesList.length})
                  </h3>
                  {failedFilesList.map((file) => (
                    <div
                      key={file.name}
                      className="mb-2 bg-red-50 p-3 rounded flex items-center"
                    >
                      <AlertCircle size={16} className="text-red-500 mr-2" />
                      <div className="text-sm truncate flex-grow">
                        {file.webkitRelativePath || file.name}
                      </div>
                      <button className="text-red-600 text-xs font-medium hover:text-red-700">
                        Retry
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Action buttons */}
            <div className="mt-4 pt-3 border-t flex justify-between">
              {/* Close button (if needed, uncomment and place here) */}

              {pendingFiles > 0 && (
                <div className="ml-auto">
                  <button
                    disabled={startUploading}
                    onClick={uploadAllFiles}
                    className={`px-4 py-2 rounded flex items-center transition 
          ${
            startUploading
              ? "bg-gray-400 text-white cursor-not-allowed"
              : "bg-blue-600 text-white hover:bg-blue-700"
          }`}
                  >
                    <ArrowUpFromLine size={16} className="mr-2" />
                    <span>
                      Upload {pendingFiles} File{pendingFiles !== 1 ? "s" : ""}
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <FileViewer
        renderFileContent={renderFileContent}
        onClose={handleClose}
        showModal={showModal}
      />
    </div>
  );
};

export default ViewFile;
